<template>
	<Dialog :open="isModalOpen(props.id)" @close="null" class="relative z-[9999999]">
		<div class="fixed inset-0 bg-black/50" aria-hidden="true" />
		<div class="fixed inset-0 flex w-screen min-h-screen items-end justify-center">
			<DialogPanel class="w-full max-w-full bg-primary_alt !p-4 relative">
				<button
					v-if="showClose"
					type="button"
					aria-label="Close Dialog"
					class="absolute top-2 right-2"
					@click="handleClosed"
				>
					<svg-vue icon="close" class="w-4" />
				</button>
				<p class="seint-text-primary text-sm font-normal pe-10 !mb-6">
					Our website uses cookies. By continuing, we assume your permission to deploy cookies as detailed in our
					<slot name="privacy-policy" />.
				</p>
				<div class="flex flex-col w-full gap-3 md:flex-row md:items-center md:justify-start ios-padding">
					<form :action="acceptCookiesEndpoint" method="POST">
						<slot name="csrf" />
						<button
							type="submit"
							@click="handleClosedWithSave"
							class="btn-primary-fg !px-4 font-semibold text-sm btn-primary-bg border btn-primary-border h-10 w-full"
						>
							Accept Cookies
						</button>
					</form>
					<form :action="rejectCookiesEndpoint" method="POST">
						<slot name="csrf" />
						<button
							type="submit"
							@click="handleClosedWithSave"
							class="btn-secondary-bg !px-4 font-semibold text-sm border btn-secondary-border w-full h-10"
						>
							Reject Cookies
						</button>
					</form>
					<div class="text-center">
						<a :href="viewCookiesRoute" class="text-sm font-medium underline">View Cookie Policy</a>
					</div>
				</div>
			</DialogPanel>
		</div>
	</Dialog>
</template>
<script setup>
import { onMounted } from 'vue'
import { storeToRefs } from 'pinia'
import { Dialog, DialogPanel } from '@headlessui/vue'

import { useAppStore, useModalStore } from '@stores'

const props = defineProps({
	showClose: {
		type: Boolean,
		default: false,
	},
	id: {
		type: String,
		default: 'cookie',
	},
	autoShow: {
		type: Boolean,
		default: false,
	},
	privacyPolicyRoute: {
		type: String,
		required: true,
	},
	acceptCookiesEndpoint: {
		type: String,
		required: true,
	},
	rejectCookiesEndpoint: {
		type: String,
		required: true,
	},
	viewCookiesRoute: {
		type: String,
		required: true,
	},
})

const emit = defineEmits(['closed'])

const appStore = useAppStore()
const { hideGorgiasChat } = appStore
const modalStore = useModalStore()
const { isModalOpen, hasModalFired } = storeToRefs(modalStore)
const { setModal, addToModalsFired, closeModal } = modalStore

onMounted(() => {
	if (props.autoShow && !hasModalFired.value(props.id)) {
		setModal(props.id, true)
		hideGorgiasChat()
	} else {
		setModal(props.id, false)
	}
})

const handleClosed = () => {
	addToModalsFired(props.id)
	closeModal(props.id)
	emit('closed')
}
const handleClosedWithSave = () => {
	addToModalsFired(props.id)
	closeModal(props.id)
	emit('closed')
}
</script>
